import styled, { css } from 'styled-components';

import { MdContentCopy } from 'react-icons/md';

import { AiOutlineContacts } from 'react-icons/ai';
import CustomInput from 'components/layout/CustomInput';
import CustomCheckBox from 'components/layout/CustomCheckBox';
import CustomButton from 'components/layout/CustomButton';

type AddressSelectProps = {
  isSelected?: boolean;
};

export const Container = styled.div`
  padding: 20px;
  padding-left: 1px;
  padding-top: unset;
`;

export const IconCodCond = styled(MdContentCopy)``;

export const IconDoc = styled(AiOutlineContacts)``;

export const InputCond = styled(CustomInput)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const InputDoc = styled(CustomInput)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const ButtonNext = styled(CustomButton)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const ButtonBack = styled(CustomButton)`
  margin-top: 16px;
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 37px;
  display: flex;
  align-items: center;
  color: #0b24fb;
  margin-top: 15px;
`;

export const Text = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 29px;
  color: #7a7a7a;
  max-width: 538px;

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const FormContainer = styled.div`
  margin-top: 32px;
`;

export const WrapSearchDocument = styled.div`
  width: 448px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: flex-end;
  margin-top: 5px;
  margin-bottom: 16px;

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const WrapSearchDocumentContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-content: center;
  cursor: pointer;
  color: #0b24fb;
`;

export const SearchDocumentText = styled.span`
  text-decoration-line: underline;
`;

export const SearchDocumentIcon = styled.div`
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background: #97f8fb;
  border-radius: 50%;
  font-weight: 500;
`;

export const CheckBoxWrap = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-start;

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const CheckBox = styled(CustomCheckBox)``;

export const CheckBoxText = styled.span`
  margin-top: 2px;
  margin-left: 8px;
  font-size: 14px;
  line-height: 19px;
  color: rgba(122, 122, 122, 0.87);

  @media (max-width: 959px) {
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
  }
`;

export const CheckBoxTextHighlight = styled.a`
  margin-left: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #0b29fb;

  text-decoration: none;
  background-color: transparent;

  &:hover {
    color: #0056b3;
    text-decoration: none;
  }

  @media (max-width: 959px) {
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
  }
`;

export const ButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;

  button {
    + button {
      margin-top: 16px;
    }
  }
`;

export const ButtonText = styled.p`  
  display: flex;
  justify-content: center;
  margin-right: 42px;
`;

export const ContainerAddress = styled.div`
  width: 500px;
  max-height: 392px;
  overflow-x: hidden;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 8px;
    background: #e8ecf1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #0b24fb;
  }

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const AddressWrap = styled.div`
  background: #ffffff;
  border: 1px solid #dadada;
  box-sizing: border-box;
  border-radius: 3px;
  width: 432px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  & + div {
    margin-top: 8px;
  }

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const AddressSelect = styled.div<AddressSelectProps>`
  position: relative;
  bottom: 16.67%;
  width: 16px;
  height: 16px;
  border: 1px solid #dadada;
  border-radius: 50%;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 1px solid #0b24fb;
    `}
`;

export const AddressSelected = styled.div`
  width: 10px;
  height: 10px;
  border: 1px solid #0b24fb;
  background: #0b24fb;
  border-radius: 50%;
`;

export const AddressText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #7a7a7a;
`;

export const NameAddressWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CorporateName = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #7a7a7a;
`;
